/**
 * JobPosting JSON-LD builder for the Careers page.
 *
 * Server-safe (pure data, no browser globals). Imported by the careers route
 * `head()` so structured data is server-rendered. One complete, accurate
 * JobPosting object per currently open role — no salary, dates, remote status,
 * or recruiter information is invented (none is visible on the site).
 */
import { JOB_OPENINGS } from "@/data/careersData";
import { ORG_ID, SITE_URL } from "@/lib/seo";

export function buildJobPostingSchema() {
  const employmentTypeMap: Record<string, string> = {
    "Full-Time": "FULL_TIME",
    "Part-Time": "PART_TIME",
    Contract: "CONTRACTOR",
    Temporary: "TEMPORARY",
  };

  return JOB_OPENINGS.map((job) => {
    const description = [
      job.summary,
      "",
      "Key Responsibilities:",
      ...job.responsibilities.map((r) => `• ${r}`),
      "",
      "Requirements:",
      ...job.requirements.map((r) => `• ${r}`),
    ].join("\n");

    return {
      "@context": "https://schema.org",
      "@type": "JobPosting",
      "@id": `${SITE_URL}/careers#${job.id}`,
      title: job.title,
      description,
      hiringOrganization: { "@id": ORG_ID },
      jobLocation: {
        "@type": "Place",
        address: {
          "@type": "PostalAddress",
          streetAddress: "Road 5156",
          addressLocality: "Askar",
          addressCountry: "BH",
        },
      },
      employmentType: employmentTypeMap[job.type] || "FULL_TIME",
      industry: "Interior Decoration & Fit-Out",
      occupationalCategory: job.department,
    };
  }).filter((obj) => obj.title);
}
